export default __webpack_public_path__ + "static/media/ic_dominica.5ebb8018.svg";